import { Container, Row } from "reactstrap";
import { BonusUi, ToastsTitle } from "../../../constants";
import ColorsScheme from "./ColorsScheme";
import DefaultToast from "./DefaultToast";
import StackingToasts from "./StackingToasts";
import TranslucentToasts from "./TranslucentToasts";
import UniqueToast from "./UniqueToast";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import LiveToast from "./liveToast";
import ToastPlacement from "./toastPlacement";

const ToastsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ToastsTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <LiveToast />
          <ColorsScheme />
          <StackingToasts />
          <TranslucentToasts />
          <DefaultToast />
          <UniqueToast />
          <ToastPlacement />
        </Row>
      </Container>
    </>
  );
};
export default ToastsContainer;
